<ng-container *ngIf="!(canBypassHealthCheck$ | async) && isWaitingForHealthAndUser">
    <div class="justify-content-center">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
</ng-container>
<ng-container
    *ngIf="(canBypassHealthCheck$ | async) || (!isWaitingForHealthAndUser && isApiHealthy)"
>
    <div
        [ngClass]="[
            (whiteLabel$ | async)?.whiteLabelClassName || '',
            containerClass || '',
            topContentAnnouncementClass || '',
            topContentGlobalSearchClass || ''
        ]"
    >
        <ng-template #alternateNavLogoTemplate>
            <ng-container *ngIf="!(whiteLabel$ | async)?.navbarCoBrandLogoAssetPath">
                <ng-container
                    *ngIf="(whiteLabel$ | async)?.navbarMainBrandLogoIconConfig as iconConfig"
                >
                    <lsq-icon
                        [type]="iconConfig.type"
                        [color]="iconConfig.color"
                        [width]="iconConfig.widthPx"
                        [height]="iconConfig.heightPx"
                    >
                    </lsq-icon>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="(whiteLabel$ | async)?.navbarCoBrandLogoAssetPath">
                <ng-container>
                    <img
                        [height]="(whiteLabel$ | async)?.navbarCoBrandLogoConfig?.heightPx || 20"
                        [src]="(whiteLabel$ | async)?.navbarCoBrandLogoAssetPath"
                    />
                </ng-container>
            </ng-container>
        </ng-template>

        <lsq-navigation
            *ngIf="!isFullScreen"
            [navigationItems]="navigationState.navigationItems"
            [settingsDropdownNavigationItems]="navigationState.settingsDropdownNavigationItems"
            [navLogoTemplate]="
                (whiteLabel$ | async)?.navbarMainBrandLogoIconConfig ||
                (whiteLabel$ | async)?.navbarCoBrandLogoAssetPath
                    ? alternateNavLogoTemplate
                    : undefined
            "
            [hideNavigation]="isMobileUploadSession"
            [hideNavigationItems]="hideNavigationItems"
            (openMobile)="openMobileNav()"
        >
            <ng-template #rightNavItems>
                <li class="right-nav-items">
                    <right-navigation-items
                        [navigationState]="navigationState"
                        [canHaveNotifications$]="canHaveNotifications$"
                    >
                    </right-navigation-items>
                </li>
            </ng-template>

            <ng-template #loggedOutRightNavItems>
                <li *ngIf="showCallUs" class="nav-item icon-nav-item">
                    <a href="tel:800-474-7606">Call Us: (800) 474-7606</a>
                </li>
            </ng-template>

            <ng-template #settingsDropdownPrepend let-eventEmitter="eventEmitter">
                <ng-container *ngIf="(hasViewProfileClaim$ | async) && !hideNavigationItems">
                    <li
                        id="profile-settings-navigation-item"
                        [style.margin-bottom]="!canAccessSwitchAccount ? '1rem' : ''"
                        [style.padding-top]="'1rem'"
                        class="dropdown-navigation-item-prepended lsq-dropdown-item lsq-dropdown-navigation-item"
                    >
                        <a
                            (click)="eventEmitter.emit($event)"
                            [routerLink]="settingsNavigationItem.routerLink"
                        >
                            <lsq-icon [type]="icons.Gear" [color]="color.Green" [width]="12">
                            </lsq-icon>
                            <span>{{ userFullName$ | async }}</span>
                            <br />
                            <span
                                ><small i18n="Settings dropdown description"
                                    >Edit profile &amp; settings</small
                                ></span
                            >
                        </a>
                    </li>
                </ng-container>
            </ng-template>

            <ng-template #settingsDropdownPrepend let-eventEmitter="eventEmitter">
                <ng-container *ngIf="canAccessSwitchAccount">
                    <li
                        id="switch-account-navigation-item"
                        class="dropdown-navigation-item-prepended lsq-dropdown-item lsq-dropdown-navigation-item"
                        [style.margin-bottom]="'1rem'"
                        [style.padding-top]="'0.8rem'"
                        [style.padding-bottom]="'0.8rem'"
                    >
                        <a
                            [routerLink]="switchCompanyNavigationItem.routerLink"
                            (click)="eventEmitter.emit($event)"
                        >
                            <lsq-icon
                                [type]="icons.SwitchCustomers"
                                [color]="color.Green"
                                [width]="12"
                            >
                            </lsq-icon>
                            <span>{{ switchCompanyNavigationItem.label }}</span>
                        </a>
                    </li>
                </ng-container>
            </ng-template>

            <ng-template #settingsDropdownAppend let-eventEmitter="eventEmitter">
                <li
                    *ngIf="isLoggedIn$ | async"
                    class="dropdown-navigation-item-appended lsq-dropdown-item lsq-dropdown-navigation-item"
                    [style.margin-top]="'1rem'"
                >
                    <a
                        [routerLink]="logoutNavigationItem.routerLink"
                        [queryParams]="logoutNavigationItem.queryParams"
                        [style.margin-top]="'1rem'"
                        (click)="eventEmitter.emit($event)"
                    >
                        <span i18n="Log out menu item">Log out of LSQ</span>
                    </a>
                </li>
            </ng-template>
        </lsq-navigation>

        <div
            class="wrapper stick-to-top top-content-height"
            aria-live="polite"
            [ngClass]="{
                'has-footer': showFooter,
                'no-navbar': isFullScreen,
                'full-screen': isFullScreen
            }"
        >
            <!-- Need to if this out otherwise it will render hidden and not measure its width correctly -->
            <lsq-announcement
                [globalSearchIsExpanded]="globalSearchService.isExpanded$ | async"
                *ngIf="!isMobileUploadSession"
            >
            </lsq-announcement>
            <global-search *claim="claim.ViewReports"> </global-search>
            <router-outlet></router-outlet>
            <lsq-footer></lsq-footer>
        </div>

        <lsq-modal></lsq-modal>
        <lsq-backdrop></lsq-backdrop>
        <ng-template #mobileNavTemplate>
            <lsq-mobile-navigation [navigationItems]="navigationState.allNavigationItems">
            </lsq-mobile-navigation>
        </ng-template>
        <lsq-action-sheet></lsq-action-sheet>
        <lsq-floating-action-button *ngIf="isFabAllowedStream | async"></lsq-floating-action-button>
        <ngx-guided-tour [topOfPageAdjustment]="topOfPageAdjustment"></ngx-guided-tour>
    </div>
</ng-container>

<ng-container
    *ngIf="!(canBypassHealthCheck$ | async) && !isWaitingForHealthAndUser && !isApiHealthy"
>
    <div [ngClass]="[containerClass || '', topContentAnnouncementClass || '']">
        <lsq-navigation [hideNavigation]="true"> </lsq-navigation>
        <div class="wrapper stick-to-top top-content-height">
            <lsq-unavailable></lsq-unavailable>
        </div>
    </div>
</ng-container>
